import './index.scss'
$(".section4 ul li").eq(0).addClass('active');
$(".section4 ul li").click(function() {
    $(this).toggleClass("active");
    $(this).find(".text").slideToggle();
})